import { ApolloClient, ObservableQuery } from '@apollo/client'
import { OperationNames, VariablesType } from '@sketch/factory'

/**
 * WARNING: We are basing this function on ApolloClient.getObservableQueries()
 * which is not documented but seems to be the only way to find and access
 * queries in the cache. We should avoid using this function as much as possible.
 *
 * @deprecated
 * Instead of getObservableQueriesByOperationName, consider using EventEmitter
 * and/or cache-and-network fetch policy to update your cache after mutations.
 */
export function getObservableQueriesByOperationName<T extends OperationNames>(
  apolloClient: ApolloClient<any>,
  operationName: T,
  filter: (query: ObservableQuery<any, VariablesType<T>>) => boolean = () =>
    true
) {
  const matchingQueries: ObservableQuery<any, VariablesType<T>>[] = []
  apolloClient.getObservableQueries().forEach(query => {
    if (query.queryName === operationName && filter(query as any)) {
      matchingQueries.push(query)
    }
  })

  return matchingQueries
}
